import { v4 } from 'uuid'
import { FunCode } from '@/constants/funcode'
import { timerInterceptor } from '@/utils/timer'
import service from '@/services'
import eventBus from '@/services/bus'
import { MTP2WebSocket } from './build'
import { Package40 } from './package'
import { parseReceivePush, parseSubscribeRsp } from './package/package40/decode'
import { subscribeListToByteArrary } from './package/package40/encode'
import Long from 'long'

export default new (class {
    /** 行情链路 */
    private socket = new MTP2WebSocket(Package40)

    /** 行情订阅集合 */
    private subscribeMap = new Map<string, string[]>()

    constructor() {
        this.socket.onOpen = () => {
            eventBus.$emit('QuoteServerStatusNotify', true)
        }

        this.socket.onClose = () => {
            eventBus.$emit('QuoteServerStatusNotify', false)
        }

        this.socket.onReconnect = () => {
            // 重新订阅商品
            this.subscribe()
        }

        this.socket.onPush = (p) => {
            const { mainClassNumber, content } = p
            if (mainClassNumber === 65 && content) {
                const result = parseReceivePush(content)
                // 通知上层 行情推送
                eventBus.$emit('QuotePushNotify', result)
            }
        }
    }

    async connect() {
        const res = await service.onReady()
        await this.socket.connect(res.quoteUrl)
    }

    /**
     * 获取服务连接状态
     * @returns 
     */
    getStatus() {
        return this.socket.connState
    }

    /**
     * 开始行情订阅
     */
    private subscribe = timerInterceptor.setDebounce(() => {
        const goodsList: Proto.QuoteReq[] = []

        this.subscribeMap.forEach((list) => {
            list.forEach((code) => {
                if (!goodsList.some((e) => e.goodsCode === code)) {
                    goodsList.push({
                        exchangeCode: 250,
                        goodsCode: code,
                        subState: 0,
                    })
                }
            })
        })

        //console.log('开始行情订阅', goodsList)
        this.connect().then(() => {
            // 订阅列表不能为空，如果空值会导致连接断开
            const codes = goodsList.length ? goodsList : [{
                exchangeCode: 250,
                goodsCode: '0',
                subState: 0,
            }]
            const content = subscribeListToByteArrary(codes, '2_TOKEN_NEKOT_', Long.fromNumber(2))

            this.socket.send({
                data: {
                    rspCode: FunCode.QuoteSubscribeRsp,
                    payload: new Package40(FunCode.QuoteSubscribeReq, content)
                },
                success: (raw) => {
                    if (raw.content) {
                        parseSubscribeRsp(raw.content).then(() => {
                            //console.log('行情订阅成功', res)
                        }).catch(() => {
                            console.error('报文解析失败', raw)
                        })
                    } else {
                        console.error('数据异常')
                    }
                },
                fail: (err) => {
                    console.error('行情订阅失败', err)
                }
            })
        })
    }, 300)

    /**
     * 创建行情订阅
     * @param goodsCodes 
     * @param key 
     * @returns 
     */
    createSubscribe = (key?: string) => {
        const uuid = key ?? v4()

        const start = (...goodsCodes: string[]) => {
            const values = this.subscribeMap.get(uuid) ?? []
            goodsCodes.forEach((code) => {
                if (code && !values.includes(code)) {
                    values.push(code)
                }
            })
            this.subscribeMap.set(uuid, values)
            this.subscribe()
        }

        return {
            uuid,
            start,
            stop: () => {
                const flag = this.subscribeMap.delete(uuid)
                if (flag) {
                    //console.log('删除订阅', uuid)
                }
                this.subscribe()
                return flag
            },
        }
    }

    /**
     * 删除行情订阅
     * @param keys 
     */
    removeSubscribe = (...keys: string[]) => {
        if (keys.length) {
            keys.forEach((key) => {
                if (this.subscribeMap.delete(key)) {
                    console.log('删除订阅', key)
                }
            })
        } else {
            console.log('取消订阅')
            this.subscribeMap.clear()
        }
        this.subscribe()
    }

    /**
     * 关闭行情链路
     */
    close() {
        this.subscribeMap.clear()
        this.socket?.close()
    }
})